/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastController, NavController, LoadingController, AlertController, ModalController, IonRouterOutlet, ActionSheetController } from '@ionic/angular';
import { Constant } from '../../shared/model/Constant';


@Component({
  selector: 'app-supplier-search',
  templateUrl: './supplier-search.component.html',
  styleUrls: ['./supplier-search.component.scss'],
})
export class SupplierSearchComponent implements OnInit {
  date: any;
  supplier: any[];
  supplierFiltered: any[];
  fDate: any;
  gDate: any;
  user: any;
  text: any;
  dateInitial: any;
  dateFinished: any;
  data: any;
  dataFiltered: [];
  dataList: any = [
    {
      id: 1,
      name: 'asddasdas',
      phone: 12444,
      nit: 523432,
      email: 'test@test.com',
      status: 'active'
    },
    {
      id: 2,
      name: 'fgfdg',
      phone: 545543211,
      nit: 876987,
      email: 'gg55522@test.com',
      status: 'active'
    },
    {
      id: 3,
      name: '234fwfsdf',
      phone: 4324234,
      nit: 5297897893432,
      email: 'sdfdfdf@test.com',
      status: 'active'
    },
    {
      id: 4,
      name: 'gdfhghgf',
      phone: 4554352,
      nit: 444444,
      email: '5asdf@test.com',
      status: 'active'
    },
    {
      id: 5,
      name: 'fgdsdfgsfdg',
      phone: 564564,
      nit: 11111,
      email: '2@test.com',
      status: 'active'
    },
  ];

  constructor() { }
  ngOnInit() { }

  onChangePage(event: any) {
    this.dataFiltered = event; //this.pageOfItems = pageOfItems;
  }


}
